import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from "lodash";

import dataFetcher from 'Parts/chore/dataFetcher';
import { fetchPurchasedTicketList, clearPurchasedTicketList, attendEvent } from '../../eventActions';
import { reportAttendeesInEvent } from '../../../../../report/reportActions';

import EventAdminAttendeesCheckinPage from './EventAdminAttendeesCheckinPage';

const mapStateToProps = state => ({
  platform: get(state, 'platform.platform'),
  campaign: get(state, 'campaign.campaign'),
  tickets: get(state, 'Event.purchasedTickets.results', []),
  pagination: get(state, 'Event.purchasedTickets.pagination', {}),
  filters: get(state, 'Event.purchasedTickets.filters'),
  search: get(state, 'Event.purchasedTickets.search'),
  orderBy: get(state, 'Event.purchasedTickets.orderBy'),
  isAttendEventInProgress: get(state, 'Event.isAttendEventInProgress'),
  locale: get(state, 'session.language'),
  isCampaignOwner: get(state, 'session.isCampaignOwner'),
  report: get(state, 'report.attendees')
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchPurchasedTicketList,
  clearPurchasedTicketList,
  attendEvent,
  reportAttendeesInEvent,
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(EventAdminAttendeesCheckinPage);
